import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ParameterEntity } from './parameter.entity';

@Index('_fk__parameter__id', ['fkParameterId'], {})
@Entity('_parameter_option')
export class ParameterOptionEntity extends BaseEntity {
	@Column('int', { name: '_fk__parameter__id', unsigned: true })
	public fkParameterId!: number;

	@Column('varchar', { name: '_text', length: 255 })
	public text!: string;

	@Column('varchar', { name: '_value', length: 255 })
	public value!: string;

	@ManyToOne(() => ParameterEntity, (parameter) => parameter.parameterOptions, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__parameter__id', referencedColumnName: 'id' }])
	public fkParameter!: ParameterEntity;
}
